import {ReactNode} from 'react';

import {ENavigationItemsSortingOrder} from './INavigationItem';

/**
 * Get navigation animation classes
 * @param {Object[]} navigationStack
 * @param {String} id
 * @returns {String}
 */
export function getAnimationClasses(navigationStack: Record<string, string> = {}, id: string): string {
	const stackKeys = Object.keys(navigationStack || {});
	const stackLength = stackKeys.length;

	if (!stackLength) {
		return '';
	}

	const navigationItemIndex = Array.from(stackKeys).indexOf(id);

	// Go out if navigation is not in stack, or stack is empty
	if (navigationItemIndex === -1 || !stackLength) {
		return '';
	}

	const classes = [];

	// Return early if it is the only navigation in the stack
	if (stackLength === 1) {
		return classes.join(' ');
	}

	// If it is before the last navigation in the stack
	if (navigationItemIndex === stackLength - 2) {
		classes.push('enter-left');
	}

	// If it is out the screen
	if (navigationItemIndex < stackLength - 2) {
		classes.push('exit-left');
	}

	return classes.join(' ');
}

/**
 * Get sorted navigation items in asc or desc order
 * @param {Object[]} children
 * @param {string} sortingOrder
 * @returns {Object[]}
 */
export function getSortedChildrenByOrder(children, sortingOrder: string): ReactNode[] {
	const sortedChildren = children.slice().sort((a, b) => {
		//using Intl.Collator for correct sorting of localized items
		const collator = new Intl.Collator(undefined, {usage: 'sort', sensitivity: 'base'});
		const getTitle = (obj) => obj?.props?.title || ''; // Fallback to an empty string if "title" is not defined
		const titleA = getTitle(a);
		const titleB = getTitle(b);
		const comparison = collator.compare(titleA, titleB);

		return sortingOrder === ENavigationItemsSortingOrder.ASCEND ? comparison : comparison * -1;
	});

	return sortedChildren;
}
